import React from "react";
import { Link } from "react-router-dom";
import {
  FaHandHoldingUsd,
  FaUserGraduate,
  FaBullhorn,
} from "react-icons/fa";

const WhyFree = () => {
  return (
    <section id="pricing" className="why-free-section section-padding">
      <div className="container">
        <div className="section-header">
          <h2>Pricing</h2>
          <p>Flexible options for institutes, tutors, and creators</p>
        </div>

        <div className="why-free-grid">
          <div className="why-free-item">
            <div className="why-free-icon">
              <FaHandHoldingUsd />
            </div>
            <h3>Pathshala Sanchalak — Free Plan</h3>
            <p>
              Start fast with Pathshala Sanchalak LMS. Includes student and
              course management, basic analytics and web dashboard access. No
              subscription fee.
            </p>
            <p style={{ marginTop: 8 }}>
              Includes an <strong>Admin Portal</strong> for institute
              management.
            </p>
            <p style={{ marginTop: 8 }}>
              Product focus: Manage schools/coaching institutes with dedicated
              apps — <strong>Chhaatr</strong> for students and{" "}
              <strong>Adhyapak</strong> for teachers (white‑label option).
            </p>
          </div>

          <div className="why-free-item">
            <div className="why-free-icon">
              <FaUserGraduate />
            </div>
            <h3>Your Brand of Pathshala Sanchalak — from ₹600/month</h3>
            <p>
              Get fully branded mobile apps, custom theming, premium dashboards,
              and higher limits. Pricing varies by students, features, storage,
              and integrations.
            </p>
            <p style={{ marginTop: 8 }}>
              Includes fully branded <strong>Chhaatr</strong> (student) and{" "}
              <strong>Adhyapak</strong> (teacher) mobile apps under your name.
            </p>
          </div>

          <div className="why-free-item">
            <div className="why-free-icon">
              <FaBullhorn />
            </div>
            <h3>Online Pathshala</h3>
            <p>
              Digital‑first LMS for content creators with branded app, secure
              streaming, online tests and integrated payments. Custom quotes
              start at ₹600/month.
            </p>
            <p style={{ marginTop: 8 }}>
              Product focus: Sell courses/content on a{" "}
              <strong>subscription‑based model</strong>. Students purchase
              access and learn via your branded app.
            </p>
            <p style={{ marginTop: 8 }}>
              Includes an <strong>Admin Portal</strong> for content, users and
              subscription management.
            </p>
          </div>
        </div>
        <div style={{ textAlign: "center", marginTop: "2rem" }}>
          <Link to="/pricing" className="button primary">
            View detailed pricing
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhyFree;
